import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CustomerService } from '../_services/customer.service';
import { User } from '../_models/user';
import { catchError, take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private customerService: CustomerService, private router : Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let currentUser: User;
    this.customerService.currentUser$.pipe(take(1)).subscribe(user => currentUser = user);
    if (currentUser){
      request = request.clone({
        setHeaders:{
          Authorization: 'Bearer ' + currentUser.token
        }
      })
    }
    //return next.handle(request);
    return next.handle(request).pipe(
      catchError(
        (err, caught) => {
          if (err.status === 401){
            this.handleAuthError();
            return of(err);
          }
          throw err;
        }
      )
    );    
  }

  private handleAuthError() {
    console.log('401, logging out');
    this.customerService.logout();

    this.router.navigateByUrl('');
  }
}
